// src/routes/PrivateRoute.tsx
import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated } from "../services/AuthService";

const PrivateRoute = () => {
    console.log(isAuthenticated());
  return isAuthenticated() ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
